// extracted by mini-css-extract-plugin
module.exports = {"SBodyTextContainer":"MainText_SBodyTextContainer__1l_YZ","SBodyText":"MainText_SBodyText__fkNKl"};